import { faCheck, faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
import {
  faChevronUp,
  faChevronDown,
  faGlobe
} from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Icons = {
  check: faCheck,
  down: faChevronDown,
  error: faExclamationCircle,
  globe: faGlobe,
  up: faChevronUp
}

const Icon = (name: string): JSX.Element => {
  const redColor = '#c63527'
  const grayColor = '#656565'

  return (
    <FontAwesomeIcon
      icon={Icons[name as keyof typeof Icons]}
      color={name === 'error' ? redColor : grayColor}
    />
  )
}

export default Icon
